// extracted by mini-css-extract-plugin
module.exports = {"logoDescription":"PartnerDesktopLogo_logoDescription__TZF6w","bnlLogo":"PartnerDesktopLogo_bnlLogo__T_9jd"};